import styled from "styled-components";
import { V3BodyGrey35 } from "./V3BodyGrey35";
import { ClampMixin, ClampMixinType } from "./ClampMixin";

export const BlogExcerpt = styled(V3BodyGrey35) <ClampMixinType>`
    font-size: 16px;
    line-height: 160%;
    ${ClampMixin}
`;